<template>
    <div class="float-left mr-1">
        <span class="text-primary">
            <i
                class="fa fa-edit fa-lg icon-button"
                title="Atualizar Investimento"
                @click.stop="abrirModal()"
            ></i>
        </span>
		<b-modal
			v-model="showModal"
			id="modalAtualizarInvestimento"
			hide-footer
		>
			<div slot="modal-title">
				Investimento -
				<b-badge variant="warning">Atualizar</b-badge>
			</div>
			<investimento-form
				tipoOperacao="a"
				:showModal="showModal"
				@modalFechado="showModal = false"
				@obterInvestimentosAtualizados="$emit('obterInvestimentosAtualizados')"
				:contrato="contrato"
				:investimento="investimento"
			></investimento-form>
		</b-modal>
    </div>
</template>

<script>
import InvestimentoForm from './InvestimentoForm'

export default {
	components: {
		InvestimentoForm
	},

	props: {
		contrato: {
			type: Object,
			default: () => ({})
		},

		investimento: {
            type: Object,
            default: () => {}
        }
	},

	data() {
		return {
			showModal: false
		}
	},

	methods: {
		abrirModal() {
			this.showModal = true
		}
	},

	created() {},

	computed: {},

	watch: {},

	validations: {}
}
</script>
